import api from './index';
//
let exports = {};

exports.getShopDeviceBrandList = function (data, callback) {// 获取设备型号中的品牌列表
    api.post('/shop/device/brand/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

//验证/修正设备导入数据
exports.validateDeviceImpModel = function (data, callback) {
    api.post('/shop/device/imp/model/validate')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//固定资产导入验证同源资产
exports.validateShopDeviceTitle = function (data, callback) {
    api.post('/shop/device/imp/model/devc/name/validate')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//执行设备模型信息导入，返回导入记录Id
exports.doDeviceImpModelImport = function (data, callback) {
    api.post('/shop/device/imp/model/import/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//逐条执行失败时，单独保存条目
exports.saveShopDeviceImpItemFailed = function (data, callback) {
    api.post('/shop/device/imp/item/failed/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//门店设备导入记录分页列表
exports.getShopDeviceImpRecListByFilter = function (data, callback) {
    api.post('/shop/device/imp/rec/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//根据文件名和店铺id检验是否重复导入
exports.validateImpFileRepetition = function (data, callback) {
    api.post('/shop/device/imp/file/repetition/validate')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//根据id查询 门店设备导入记录 带详细
exports.getShopDeviceImpRecById = function (data, callback) {
    api.post('/shop/device/imp/rec/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//门店设备导入记录详细列表(分页)
exports.getShopDeviceImpItemPageListByFilter = function (data, callback) {
    api.post('/shop/device/imp/item/page/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//提交门店导入设备导出数据，返回下载url
exports.saveDeviceImpModelForExport = function (data, callback) {
    api.post('/shop/device/imp/model/for/export/url')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.saveDeviceImpModel = function (data, callback) {
    api.post('/shop/device/imp/model/save')
    .data(data)
    .done(callback)
    .fail(callback)
    .go()
};
exports.deleteShopDeviceImpRecById = function (data, callback) {
    api.post('/shop/device/imp/rec/delete')
    .data(data)
    .done(callback)
    .fail(callback)
    .go()
};
exports.doImpRecCheck = function (data, callback) {
    api.post('/shop/device/imp/rec/check')
    .data(data)
    .done(callback)
    .fail(callback)
    .go()
};
exports.doStopImpRec = function (data, callback) {
    api.post('/shop/device/imp/rec/stop/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go()
};
exports.doImpRecInFiscal = function (data, callback) {
    api.post('/shop/device/imp/rec/in/fiscal/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go()
};
exports.doImpRecDone = function (data, callback) {
    api.post('/shop/device/imp/rec/done')
    .data(data)
    .done(callback)
    .fail(callback)
    .go()
};
exports.updateDeviceImpItemListModel = function (data, callback) {
    api.post('/shop/device/imp/item/list/model/save')
    .data(data)
    .done(callback)
    .fail(callback)
    .go()
};

// 提交门店设备导出过滤参数，返回下载url
exports.saveDeviceParamsForExport = function (data, callback) {
    api.post('/shop/device/exp/params/for/export/url')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 提交门店设备导出数据，返回下载url
exports.saveDeviceModelForExport = function (data, callback) {
    api.post('/shop/device/exp/model/for/export/url')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 子设备批量设置责任部门、责任人
exports.doShopDevicePrincipalSet = function (data, callback) {
    api.post('/shop/device/update/principal/do')
    .data(data)
    .done(callback)
    .go();
};

exports.updateShopDeviceForTitle = function (data, callback) {      // 批量修改子设备名称
    api.post('/shop/device/update/title/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.updateShopDeviceForTheValue = function (data, callback) {      // 修改预警值
    api.post('/shop/device/update/theValue/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.updateShopDeviceBizTagByIds = function (data, callback) {//批量修改设备中的标签
    api.post('/shop/device/bizTag/update/by/ids')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.updateShopDeviceBizTagById = function (data, callback) {//批量修改设备中的标签
    api.post('/shop/device/bizTag/update/by/id')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.updateShopDeviceTemperInfoByIds = function (data, callback) {//批量修改设备中的标签
    api.post('/shop/device/temperInfo/update/by/ids')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.updateShopDeviceLayoutAreaIdByIds = function (data, callback) {// 给设备设置布放区
    api.post('/shop/device/layoutAreaId/update/by/ids')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.updateShopDeviceLayoutAreaIdNoneByLayoutAreaId = function (data, callback) {// 取消指定布放区域的全部设备
    api.post('/shop/device/set/layoutAreaIdNone/by/layoutAreaId')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.updateDevcCustInfo = function (data, callback) {    // 设置归类标签
    api.post('/shop/device/cust/info/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.saveShopAsmbleAccIoRecForAssect = function (data, callback) {   // 组装
    api.post('/shop/device/update/for/asmbleAcc/do')
    .data(data)
    .done(callback)
    .go();
};

exports.saveShopAsmbleAccIoRecByShopDevice = function (data, callback) {   // 资产关联待用组装件
    api.post('/shop/device/rel/asmbleAcc/update/do')
    .data(data)
    .done(callback)
    .go();
};

exports.updateShopDeviceAbscent = function (data, callback) {      // 无实物
    api.post('/shop/device/update/abscent/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 编辑
exports.updateShopDevice = function (data, callback) {
    api.post('/shop/device/update/do')
    .data(data)
    .done(callback)
    .go();
};

// 财务类别-批量设置
exports.updateAssetKind = function (data, callback) {
    api.post('/shop/device/asset/kind/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 设备/资产更换定义
exports.doChangeAssetDevcDef = function (data, callback) {
    api.post('/shop/device/asset/devcDef/change/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 门店设备服务子号--关联初始合同
exports.doShopDeviceRelContract = function (data, callback) {
    api.post('/shop/device/rel/contract/do')
    .data(data)
    .done(callback)
    .go();
};

// 批量设置在账 - 设备
exports.batchSetShopDeviceFiscalAcctFlag = function (data, callback) {
    api.post('/shop/device/fiscalAcctFlag/batch/set/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 修改批次的巡检信息
exports.updateShopDevicePatrolFlagByIds = function (data, callback) {
    api.post('/shop/device/patrolFlag/ids')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 首次启用
exports.updateShopDeviceForStart = function (data, callback) {
    api.post('/shop/device/useState/set/start/do')
        .data(data)
        .done(callback)
        .go();
};
// 启用
exports.updateShopDeviceStarted = function (data, callback) {
    api.post('/shop/device/useState/set/do')
    .data(data)
    .done(callback)
    .go();
};

exports.updateShopDeviceState = function (data, callback) {
    api.post('/shop/device/update/state/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.updateShopDeviceTagMissing = function (data, callback) {
    api.post('/shop/device/tagMissing/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 修改设备的抢单标记
exports.updateShopDeviceGrabIssueAllowedByIds = function (data, callback) {
    api.post('/shop/device/grabIssueAllowed/ids')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 修改设备的保养标记
exports.updateShopDeviceMainFlagByIds = function (data, callback) {
    api.post('/shop/device/maintFlag/ids')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 修改的安装信息
exports.updateShopDeviceSetupFlagByIds = function (data, callback) {
    api.post('/shop/device/setupFlag/ids')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 修改设备的检验信息
exports.updateShopDeviceInspectFlagByIds = function (data, callback) {
    api.post('/shop/device/inspectFlag/ids')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.updateShopDeviceInspectFlowIdByIds = function (data, callback) {
    api.post('/shop/device/inspectFlowId/ids')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 修改设备的需维修标记
exports.updateShopDeviceRepairFlagByIds = function (data, callback) {
    api.post('/shop/device/repairFlag/ids')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 获取多个资产编码============================= 走的老的rest接口
exports.getBatchAssetInnerCodeByContext = function (data/*需要生成资产编码的数据集合*/, callback) {
    api.post('/shop/devc/batch/asset/innerCode/By/context')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getShopDeviceListByFilter = function (data, callback) {
    api.post('/shop/device/page/list')
    .data(data)
    .done(function (result) {
        if(result.type == 'info') {
            let rows = result.data.rows || [];
            rows.forEach(function (item) {
                if(!Utils.isNoB(item.devcMgmtAspkt)) {
                    item = Object.assign(item, item.devcMgmtAspkt);
                }
                if(!Utils.isNoB(item.devcAssetAspkt)) {
                    item = Object.assign(item, item.devcAssetAspkt);
                }
                if(!Utils.isNoB(item.devcMaintAspkt)) {
                    item = Object.assign(item, item.devcMaintAspkt);
                }
            });
            result.data.rows = rows;
        }
        callback(result);
    })
    .fail(callback)
    .go();
};

exports.getShopDeviceListForReceive = function (data, callback) {
    api.post('/shop/device/list/get/for/receive')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getAssetListByFilterForOpen = function (data, callback) {
    api.post('/shop/device/list/for/open')
    .data(data)
    .done(callback)
    .fail(callback)
    .go()
}

exports.getShopDeviceById = function (data, callback) {
    api.get('/shop/device/get/by/id')
    .params(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getShopDeviceByNo = function (data, callback) {
    api.get('/shop/device/get/by/no')
    .params(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getShopDeviceByTmpNo = function (data, callback) {
    api.get('/shop/device/get/by/tmpNo')
    .params(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 获取资产详情（根据资产编码获取资产详情）
exports.getAssetInfoByInnerCode = function (data, callback) {// 获取资产详情（根据资产编码获取资产详情）
    api.post('/shop/device/asset/info/get')
    .data(data)
    .done(function (result) {
        if(result.type == 'info') {
            let assetInfo = result.data.assetInfo || {};
            // 管理
            if(!Utils.isNoB(assetInfo.devcMgmtAspkt)) {
                assetInfo = Object.assign(assetInfo, assetInfo.devcMgmtAspkt);
            }
            // 资产
            if(!Utils.isNoB(assetInfo.devcAssetAspkt)) {
                assetInfo = Object.assign(assetInfo, assetInfo.devcAssetAspkt);
            }
            // 维保
            if(!Utils.isNoB(assetInfo.devcMaintAspkt)) {
                assetInfo = Object.assign(assetInfo, assetInfo.devcMaintAspkt);
            }
            result.data.assetInfo = assetInfo;
        }
        callback(result);
    })
    .go();
};

// ============================== 待入账资产导入 ======================
exports.saveWaitInFiscalDeviceImpParamsForExport = function (data, callback) {
    api.post('/shop/device/waitInFiscal/device/params/for/export/url')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//验证/修正设备导入数据
exports.validateDeviceFiscalInImpModel = function (data, callback) {
    api.post('/shop/device/fiscal/in/imp/model/validate')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.doDeviceFiscalInImpModelImport = function (data, callback) {
    api.post('/shop/device/fiscal/in/imp/model/import/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 资产相关状态更新导入
exports.validateAssetBizStateImpModel = function (data, callback) {
    api.post('/shop/device/asset/bizState/imp/model/validate')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.doAssetBizStateImpModelImport = function (data, callback) {
    api.post('/shop/device/asset/bizState/imp/model/import/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 资产折旧测试
exports.doAssetDeprTest = function (data, callback) {
    api.post('/shop/device/asset/depr/test/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 资产折旧计提
exports.doAssetDeprRecExtracted = function (data, callback) {
    api.post('/shop/device/asset/depr/extracted/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// ============================ 设备关联部件 =========================
exports.getDevcRelatedPartPageList = function (data, callback) {
    api.post('/shop/device/related/part/page/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.saveDevcRelatedPart = function (data, callback) {
    api.post('/shop/device/related/part/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 批量添加设备部件
exports.saveDevcRelatedParts = function (data, callback) {
    api.post('/shop/device/related/parts/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 设为可维修的
exports.doDevcRelatedPartRepairable = function (data, callback) {
    api.post('/shop/device/related/part/repairable/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 移除设备部件
exports.doDeleteDevcRelatedPart = function (data, callback) {
    api.post('/shop/device/related/part/delete/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getShopDeviceIdleForIdle = function (data, callback) {   // 批次库存闲置信息  -- 汇总
    api.post('/shop/device/idle/statc')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getShopDeviceFiscalIdleCollect = function (data, callback) {
    api.post('/shop/device/fiscal/idle/collect')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.saveDeviceMaintPlanForOneServicerBatch = function (data, callback) { // 保存设备保养计划
    api.post('/shop/device/maint/plan/save/do/for/oneServicer/batch')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.updateDeviceMaintPlanForPage = function (data, callback) { // 保存设备保养计划
    api.post('/shop/device/maint/plan/update/for/oneServicer')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.saveDeviceMaintPlan = function (data, callback) { // 保存设备保养计划 - 一个服务商一个保养计划
    api.post('/shop/device/maint/plan/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.deleteDeviceMaintPlan = function (params, callback) { // 删除设备保养计划
    api.post('/shop/device/maint/plan/delete/do')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.doBatchDeleteDeviceMaintPlan = function (data, callback) { // 批量删除设备保养计划
    api.post('/shop/device/maint/plan/batch/delete/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.doDeviceMaintPlanTermina = function (params, callback) { // 结束设备保养计划
    api.post('/shop/device/maint/plan/termina/do')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.doDeviceMaintPlanTerminaBatch = function (params, callback) { // 结束设备保养计划
    api.post('/shop/device/maint/plan/termina/batch/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
// 保养计划批量设置标签操作
exports.updateMaintPlanBizTag = function (data, callback) {
    api.post('/shop/device/maint/plan/bizTag/update')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getDeviceMaintPlanDetail = function (params, callback) { // 获取设备保养计划列表
    api.get('/shop/device/maint/plan/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};

// （零售）门店设备套装-分页列表
exports.getShopDeviceSuitPaginatedList = function (data, callback) {
    api.post('/shop/device/suit/paginated/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// （零售）门店设备套装-根据id查询
exports.getShopDeviceSuitById = function (data, callback) {
    api.post('/shop/device/suit/get/by/id')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// （零售）门店设备套装-保存
exports.saveShopDeviceSuit = function (data, callback) {
    api.post('/shop/device/suit/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// （零售）门店设备套装-修改
exports.updateShopDeviceSuit = function (data, callback) {
    api.post('/shop/device/suit/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// （零售）门店设备套装-解散删除
exports.deleteShopDeviceSuit = function (data, callback) {
    api.post('/shop/device/suit/delete/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 提交门店设备套装导出过滤参数，返回导出文件所需uuid
exports.saveSuitParamsForExport = function (data, callback) {
    api.post('/shop/device/exp/params/for/export/suit/url')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 提交门店设备套装导出数据，返回导出文件所需uuid
exports.saveSuitModelForExport = function (data, callback) {
    api.post('/shop/device/exp/model/for/export/suit/url')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getShopDeviceListForCollect = function (data, callback) {   // 设备数量汇总
    api.post('/shop/device/list/get/for/collect')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 在账资产数量汇总
exports.getShopDeviceListForFiscalCollect = function (data, callback) {
    api.post('/shop/device/list/get/for/fiscal/collect')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getPcComDevcDefItemList = function (data, callback) {
    api.post('/shop/device/com/devcDef/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getShopDeviceByPrincipalId = function (data, callback) {
    api.post('/shop/device/get/by/principalId')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 获取待调整资产
exports.getReadyAdjustAssetList = function (data, callback) {
    api.post('/shop/device/ready/adjust/asset/list/get')
    .data(data)
    .done(function (result) {
        if(result.type == 'info') {
            let rows = result.data.rows || [];
            rows.forEach(function (item) {
                if(!Utils.isNoB(item.devcMgmtAspkt)) {
                    item = Object.assign(item, item.devcMgmtAspkt);
                }
                if(!Utils.isNoB(item.devcAssetAspkt)) {
                    item = Object.assign(item, item.devcAssetAspkt);
                }
                if(!Utils.isNoB(item.devcMaintAspkt)) {
                    item = Object.assign(item, item.devcMaintAspkt);
                }
                if(!Utils.isNoB(item.devcOtherDto)) {
                    item = Object.assign(item, item.devcOtherDto);
                }
            });
            result.data.rows = rows;
        }
        callback(result);
    })
    .fail(callback)
    .go();
};

exports.getDevicePatrolRecByShopDevcInfo = function (data, callback) {
    api.post('/shop/device/patrol/rec/list/get/by/shop/devc')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getShopDeviceCount = function (data, callback) {
    api.post('/shop/device/count/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// ====================== 设备拆分单 ======================

exports.getDevcSplitFormPageList = function (data, callback) {// 获取 - 设备拆分单列表
    api.post('/shop/device/split/form/page/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getDevcSplitFormDetail = function (params, callback) {// 获取拆分单详情
    api.get('/shop/device/split/form/detail/get')
    .params(params)
    .done(callback)
    .go();
};

exports.saveDevcSplitForm = function (data, callback) {// 保存设备拆分单
    api.post('/shop/device/split/form/save/do')
    .data(data)
    .done(callback)
    .go();
};

exports.doApplyDevcSplitForm = function (data, callback) {// 设备拆分单申请操作
    api.post('/shop/device/split/form/apply/do')
    .data(data)
    .done(callback)
    .go();
};

exports.doAuditDevcSplitForm = function (data, callback) {// 设备拆分单审核操作
    api.post('/shop/device/split/form/audit/do')
    .data(data)
    .done(callback)
    .go();
};

exports.doDeleteDevcSplitForm = function (data, callback) {// 设备拆分单删除操作
    api.post('/shop/device/split/form/delete/do')
    .data(data)
    .done(callback)
    .go();
};

exports.getDevcSplitAuditRecList = function (params, callback) {// 获取设备拆分单审核操作列表
    api.get('/shop/device/split/audit/rec/list/get')
    .params(params)
    .done(callback)
    .go();
};
// ====================== 设备合并单 ======================

exports.getDevcMergeFormPageList = function (data, callback) {// 获取 - 设备合并单列表
    api.post('/shop/device/merge/form/page/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getDevcMergeFormDetail = function (params, callback) {// 获取合并单详情
    api.get('/shop/device/merge/form/detail/get')
    .params(params)
    .done(callback)
    .go();
};

exports.saveDevcMergeForm = function (data, callback) {// 保存设备合并单
    api.post('/shop/device/merge/form/save/do')
    .data(data)
    .done(callback)
    .go();
};

exports.doApplyDevcMergeForm = function (data, callback) {// 设备合并单申请操作
    api.post('/shop/device/merge/form/apply/do')
    .data(data)
    .done(callback)
    .go();
};

exports.doAuditDevcMergeForm = function (data, callback) {// 设备合并单审核操作
    api.post('/shop/device/merge/form/audit/do')
    .data(data)
    .done(callback)
    .go();
};

exports.doDeleteDevcMergeForm = function (data, callback) {// 设备合并单删除操作
    api.post('/shop/device/merge/form/delete/do')
    .data(data)
    .done(callback)
    .go();
};

exports.getDevcMergeAuditRecList = function (params, callback) {// 获取设备合并单审核操作列表
    api.get('/shop/device/merge/audit/rec/list/get')
    .params(params)
    .done(callback)
    .go();
};
exports.updateDevcAssetAspktAssetIdleX = function (data, callback) {
    api.post('/shop/device/update/assetIdleX/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 获取设备账面值版本记录列表
exports.getDevcAcntVersionRecList = function (data, callback) {
    api.post('/shop/device/devc/acnt/version/rec/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/devc.js
// module id = 23
// module chunks = 0